import { securedAxiosInstance } from "@/api/axios";
import { toCamelCase, toSnakeCase } from "@estaly/ui/src/utils/data_formatter";

const initialState = {
  index: [],
  currentPage: 1,
  totalPages: 0,
  totalCount: 0,
};

export default {
  namespaced: true,
  state: initialState,
  mutations: {
    setIndex(state, data) {
      state.index = data.contractDistributions;
      state.currentPage = data.page.currentPage || 1;
      state.totalPages = data.page.totalPages || 0;
      state.totalCount = data.page.totalCount || 0;
    },
  },
  actions: {
    async fetchIndex({ commit }, { storeId, page } = {}) {
      const response = await securedAxiosInstance.get("/contract_distributions", {
        params: toSnakeCase({ storeId, page }),
      });
      if (!response?.success) return response;

      const data = toCamelCase(response.data);
      commit("setIndex", data);
      return data;
    },
    async fetch(_, { id, includes = [] } = {}) {
      const params = {};
      if (includes.length > 0) {
        params.includes = includes.join(",");
      }
      const response = await securedAxiosInstance.get(`/contract_distributions/${id}`, { params });
      if (!response?.success) return response;

      return toCamelCase(response.data);
    },
    async orderKit(_, { id, storeId }) {
      const response = await securedAxiosInstance.post(`/contract_distributions/${id}/order_kit`, {
        store_id: storeId,
      });
      if (!response?.success) return response;

      return response;
    },
  },
};
